var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowmobLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2617 6.2555H3.7527L7.86817 2.14003C7.98541 2.02374 8.07847 1.88539 8.14198 1.73296C8.20549 1.58053 8.23818 1.41703 8.23818 1.25189C8.23818 1.08676 8.20549 0.923259 8.14198 0.770825C8.07847 0.618391 7.98541 0.48004 7.86817 0.363753C7.6338 0.130771 7.31675 0 6.98628 0C6.65581 0 6.33877 0.130771 6.1044 0.363753L0.738032 5.74263C0.268209 6.20965 0.002793 6.84395 0 7.5064C0.00608762 8.1645 0.271251 8.7937 0.738032 9.25766L6.1044 14.6365C6.22103 14.7523 6.35933 14.8441 6.5114 14.9064C6.66348 14.9688 6.82634 15.0006 6.99071 15C7.15507 14.9994 7.31771 14.9665 7.46933 14.903C7.62096 14.8396 7.75861 14.7469 7.87442 14.6303C7.99023 14.5136 8.08194 14.3753 8.1443 14.2233C8.20666 14.0712 8.23846 13.9083 8.23788 13.744C8.2373 13.5796 8.20435 13.417 8.14092 13.2653C8.07748 13.1137 7.9848 12.9761 7.86817 12.8603L3.7527 8.7573H16.2617C16.5935 8.7573 16.9116 8.62551 17.1462 8.39092C17.3808 8.15633 17.5126 7.83816 17.5126 7.5064C17.5126 7.17464 17.3808 6.85647 17.1462 6.62188C16.9116 6.38729 16.5935 6.2555 16.2617 6.2555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowmobLeft);
export default __webpack_public_path__ + "static/media/arrowmob-left.b051ed5308f8d6d74bb0c9bb7575d9cf.svg";
export { ForwardRef as ReactComponent };